import { render, staticRenderFns } from "./StandardButtons.vue?vue&type=template&id=338f792c&scoped=true"
import script from "./StandardButtons.vue?vue&type=script&lang=js"
export * from "./StandardButtons.vue?vue&type=script&lang=js"
import style0 from "./StandardButtons.vue?vue&type=style&index=0&id=338f792c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f792c",
  null
  
)

export default component.exports